import { TabStyles } from '@tableau/widgets';
import { BodyCell, DataGrid } from '@tableau/widgets-datagrid';
import React from 'react';
import _ from 'underscore';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { generateUniqueId } from '~src/spacesPlatform/utils/DomUtils';
import { cssClass } from '~src/style';

import { CollectionsPrivateIndicator, CollectionsPrivateIndicatorIdPrefix } from '../../../../Collections/space/CollectionsPrivateIndicator';
import { ICollectionInfo } from '../../../../Collections/space/ICollectionInfo';
import { StyledCellFormatter } from '../StyledCellWrapper';
import { getLinkMarkup, ILink } from './LinkCell';

export function LinkWithCollectionVisibility(linkFn: (row: DataGrid.Row) => ILink): React.StatelessComponent<BodyCell.Props> {
  return StyledCellFormatter(
      React.createFactory(class extends React.Component<BodyCell.Props, any> {
        public render() {
          const textEllipsis = CommonStyles.Layout.TextEllipsis;
          const shouldDisplayPrivateIndicator = (this.props.row.data as ICollectionInfo).visibility === 'private';
          const privateIndicatorId = shouldDisplayPrivateIndicator ? generateUniqueId(CollectionsPrivateIndicatorIdPrefix) : '';

          const link: ILink = linkFn(this.props.row);
          if (!link) {
            return null;
          }

          return (
            <span data-tb-test-id={link.testId} style={CommonStyles.Layout.FlexBlockLeftAndCenter}>
              {link.displayJustText ?
                <span
                  title={link.hideTooltips ? null : (link.title || link.text)}
                  style={_.extend({display: 'block'}, textEllipsis, link.style)}
                  aria-labelledby={privateIndicatorId}
                >
                  {link.text}
                </span>
                : getLinkMarkup(link, this.props.row, privateIndicatorId)
              }
              {shouldDisplayPrivateIndicator &&
                <span className={PrivateCollectionAreaListView} id={privateIndicatorId}>
                  <CollectionsPrivateIndicator />
                </span>
              }
          </span>
          );
        }
      })
  );
}

const PrivateCollectionAreaListView = cssClass('collections-private-indicator', 'list-view', {
  paddingLeft: TabStyles.Spacing.DefaultSpace,
  fontSize: '12px',
  fontWeight: 'normal'
});
